// Libs
import Vue from 'vue'
import Router from 'vue-router'
// Main Components
import Home from '@/components/Home'
import CreateProfile from '@/components/CreateProfile'
import TrainingList from '@/components/TrainingList'
// Settings Components
import EatingPlan from '@/components/Settings/EatingPlan'
import Profile from '@/components/Settings/Profile'
import PaymentConfirm from '@/components/Settings/PaymentConfirm'
import ReciptFind from '@/components/Settings/ReciptFind'
import Statisitc from '@/components/Settings/Statisitc'
import Training from '@/components/Settings/Training'
import TrainingFlow from '@/components/Settings/TrainingFlow'
import TrainingEnd from '@/components/Settings/TrainingEnd'
// Pages
import DeactivationSuccess from '@/components/Pages/DeactivationSuccess'
import PaymentError from '@/components/Pages/PaymentError'
// LangKyfuage Specific
import Wait from '@/components/LangKyf/BG/Wait'
import Deactivation from '@/components/LangKyf/BG/Deactivation'
import Contact from '@/components/LangKyf/BG/Contact'
import Imprint from '@/components/LangKyf/BG/Imprint'
import Terms from '@/components/LangKyf/BG/Terms'
import LP from '@/components/LangKyf/BG/LP'
import LPOtp from '@/components/LangKyf/BG/LPOtp'
import LPDcb from '@/components/LangKyf/BG/LPDcb'


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/create-profile',
            name: 'CreateProfile',
            component: CreateProfile
        },
        {
            path: '/deactivation',
            name: 'Deactivation',
            component: Deactivation
        },
        {
            path: '/deactivation-success',
            name: 'DeactivationSuccess',
            component: DeactivationSuccess
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/imprint',
            name: 'Imprint',
            component: Imprint
        },
        {
            path: '/terms-and-conditions',
            name: 'Terms',
            component: Terms
        },
        {
            path: '/eating-plan',
            name: 'EatingPlan',
            component: EatingPlan
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },
        {
            path: '/recipt-find',
            name: 'ReciptFind',
            component: ReciptFind
        },
        {
            path: '/lp',
            name: 'LP',
            component: LP
        },
        {
            path: '/lpotp',
            name: 'LPOtp',
            component: LPOtp
        },
        {
            path: '/lpdcb',
            name: 'LPDcb',
            component: LPDcb
        },
        {
            path: '/statisitc',
            name: 'Statisitc',
            component: Statisitc
        },
        {
            path: '/training',
            name: 'Training',
            component: Training
        },
        {
            path: '/training-program',
            name: 'TrainingFlow',
            component: TrainingFlow
        },
        {
            path: '/training-end',
            name: 'TrainingEnd',
            component: TrainingEnd
        },
        {
            path: '/payment-confirmation',
            name: 'PaymentConfirm',
            component: PaymentConfirm
        },
        {
            path: '/payment-error',
            name: 'PaymentError',
            component: PaymentError
        },
        {
            path: '/wait',
            name: 'Wait',
            component: Wait
        },
        {
            path: '/training-list',
            name: 'TrainingList',
            component: TrainingList
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/kyf/bg.js